export const resetServicePrices = (services = []) => {
  return services.map((i) => {
    i.netPrice = i.grossPrice;
    return i;
  });
};

export const resetServiceTax = (
  services = [],
  serviceTax = null,
  lookupZipCodeTax = null,
  setNetPrice,
  discount,
) => {
  return services.map((i) => {
    return i;
  });
};
